import { createSlice } from '@reduxjs/toolkit';
import { merge } from 'lodash';

export const theme = createSlice({
  name: 'THEME',
  initialState: {}, // declare in store, not here which gets overwritten by store

  reducers: {
    setPaletteOverrides(state, action) {
      const { payload } = action;

      const formattedPaletteOverrides = {
        component: {
          answerSelectedColor: payload.answerSelectedColor,
          answerUnselectedColor: payload.answerUnselectedColor,
          continueButtonColor: payload.continueButtonColor,
          continueButtonHoverColor: payload.continueButtonHoverColor,
          backButtonColor: payload.backButtonColor,
          backButtonHoverColor: payload.backButtonHoverColor,
          progressBarFilledColor: payload.progressBarFilledColor
            ? payload.progressBarFilledColor
            : payload.answerSelectedColor,
          scrollIndicatorColor: payload.scrollIndicatorColor,
        },
        background: {
          answerBackgroundColor: payload.answerBackgroundColor,
          secondaryBackgroundColor: payload.secondaryBackgroundColor,
          widgetBackgroundColor: payload.widgetBackgroundColor,
        },
        text: {
          primaryTextColor: payload.primaryTextColor,
          continueButtonTextColor: payload.continueButtonTextColor,
          secondaryTextColor: payload.secondaryTextColor,
          legalStatementTextColor: payload.legalStatementTextColor,
          legalStatementLinkColor: payload.legalStatementLinkColor,
        },
      };

      merge(state.palette, formattedPaletteOverrides);
    },
  },
});

const { actions, reducer } = theme;

export const { setPaletteOverrides } = actions;

export default reducer;
